import React from 'react'
import { number } from 'prop-types'
import { SVGIcon } from 'components/qstrap'

const ProfessionSalaryItem = ({ minSalary, maxSalary }) => (
  <div className="profession-item-salary">
    <SVGIcon name="campus-money" className="profession-item-salary-icon m-r" />
    <div className="profession-item-salary__text">
      Rp. {(minSalary > 0) && minSalary / 1000000} {!!(minSalary && maxSalary) && ' - '} {(maxSalary > 0) && maxSalary / 1000000} jt
    </div>
    <style jsx>
      {`
        .profession-item-salary {
          background-color: #EBEEF3;
          color: #7d92a9;
          padding: 4px 8px;
          border-radius: 4px;
          &__text {
            display: inline-block
          }
          :global(svg) {
            color: #2440a4;
          }
        }
      `}
    </style>
  </div>
)

ProfessionSalaryItem.propTypes = {
  minSalary: number,
  maxSalary: number,
}

export default ProfessionSalaryItem
